var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create__global__alert" },
    [
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var handleSubmit = ref.handleSubmit
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.saveGlobalAlert)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_vm._v("Users")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "float-right" }, [
                          !_vm.showDeselectAll
                            ? _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: { click: _vm.selectAllUser }
                                },
                                [_vm._v("Select all")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showDeselectAll
                            ? _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: { click: _vm.deSelectAllUser }
                                },
                                [_vm._v("Deselect all")]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("ValidationProvider", {
                          attrs: { mode: "passive", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("multiselect", {
                                      ref: "alertUser",
                                      attrs: {
                                        "track-by": "id",
                                        label: "name",
                                        "open-direction": "bottom",
                                        options: _vm.allActiveUsers,
                                        "show-labels": false,
                                        multiple: true,
                                        allowEmpty: false,
                                        "close-on-select": false,
                                        "hide-selected": false,
                                        "preserve-search": true,
                                        "clear-on-select": true
                                      },
                                      model: {
                                        value: _vm.alertUser,
                                        callback: function($$v) {
                                          _vm.alertUser = $$v
                                        },
                                        expression: "alertUser"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "validate-error text-danger"
                                      },
                                      [_vm._v(_vm._s(errors[0]))]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_vm._v("Alert Type")]),
                        _vm._v(" "),
                        _c("multiselect", {
                          ref: "alertType",
                          attrs: {
                            "track-by": "id",
                            label: "name",
                            "open-direction": "bottom",
                            options: _vm.alertTypes,
                            "show-labels": false,
                            multiple: false,
                            allowEmpty: false,
                            "close-on-select": true,
                            "hide-selected": false,
                            "preserve-search": true,
                            "clear-on-select": true
                          },
                          model: {
                            value: _vm.alertType,
                            callback: function($$v) {
                              _vm.alertType = $$v
                            },
                            expression: "alertType"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_vm._v("Title")]),
                        _vm._v(" "),
                        _c("ValidationProvider", {
                          attrs: { mode: "passive", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.alertTitle,
                                          expression: "alertTitle"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Title"
                                      },
                                      domProps: { value: _vm.alertTitle },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.alertTitle = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "validate-error text-danger"
                                      },
                                      [_vm._v(_vm._s(errors[0]))]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_vm._v("Message")]),
                        _vm._v(" "),
                        _c("ValidationProvider", {
                          attrs: { mode: "passive", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("ckeditor", {
                                      attrs: {
                                        editorUrl: "/js/ckeditor/ckeditor.js",
                                        placeholder: "Message",
                                        config: _vm.editorConfig
                                      },
                                      model: {
                                        value: _vm.alertMessage,
                                        callback: function($$v) {
                                          _vm.alertMessage = $$v
                                        },
                                        expression: "alertMessage"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "validate-error text-danger"
                                      },
                                      [_vm._v(_vm._s(errors[0]))]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "header-filter-btns",
                            attrs: { type: "submit", variant: "theme" }
                          },
                          [
                            _vm._v("\n          Send Alert\n          "),
                            _c("i", {
                              staticClass:
                                "fas text-primary fa-paper-plane fa-fw float-right"
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }